import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';

// Used by GTPL Bulk Change Order and A la Carte Bulk to narrow the customer picker.
// Tick several areas (societies) at once; none ticked = all areas.
export default function AreaMultiSelect({ areas, counts, value, onChange }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);
  const toggle = (a) => { const n = new Set(value); if (n.has(a)) n.delete(a); else n.add(a); onChange(n); };
  const list = areas.filter((a) => a.toLowerCase().includes(q.trim().toLowerCase()));
  const label = value.size === 0 ? `All areas (${areas.length})` : value.size === 1 ? [...value][0] : `${value.size} areas selected`;
  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button type="button" className="form-control" aria-label="Filter by area" aria-expanded={open} onClick={() => setOpen((o) => !o)}
        style={{ minWidth: 220, maxWidth: 280, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, textAlign: 'left', cursor: 'pointer' }}>
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{label}</span><ChevronDown size={14} />
      </button>
      {open && (
        <div style={{ position: 'absolute', zIndex: 20, top: 'calc(100% + 4px)', left: 0, width: 300, background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 10, boxShadow: '0 8px 24px rgba(0,0,0,.15)', padding: 8 }}>
          <input className="form-control" autoFocus placeholder="Find area" value={q} onChange={(e) => setQ(e.target.value)} style={{ marginBottom: 6 }} aria-label="Find area" />
          <div className="flex items-center gap-2" style={{ marginBottom: 6 }}>
            <button type="button" className="btn btn-secondary btn-sm" onClick={() => onChange(new Set([...value, ...list]))}>Tick {q.trim() ? 'found' : 'all'}</button>
            <button type="button" className="btn btn-secondary btn-sm" onClick={() => onChange(new Set())}>Clear</button>
          </div>
          <div style={{ maxHeight: 280, overflowY: 'auto' }}>
            {list.map((a) => (
              <label key={a} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 4px', cursor: 'pointer', fontSize: '.88rem' }}>
                <input type="checkbox" checked={value.has(a)} onChange={() => toggle(a)} />
                <span style={{ flex: 1 }}>{a}</span><span className="text-muted text-small">{counts[a] || 0}</span>
              </label>
            ))}
            {list.length === 0 && <div className="text-muted text-small" style={{ padding: 6 }}>No area matches</div>}
          </div>
        </div>
      )}
    </div>
  );
}
